import '.c7{position:relative;}.ssr-plugin'
import '.hz{width:64px;}.ssr-plugin'
import '.i0{height:64px;}.ssr-plugin'
import '.by{flex-shrink:0;}.ssr-plugin'
import '.i{position:absolute;}.ssr-plugin'
import '.i1{bottom:-4px;}.ssr-plugin'
import '.dj{right:-4px;}.ssr-plugin'
import '.d8{border-radius:50%;}.ssr-plugin'
import '.i2{border:2px solid var(--shades-white);}.ssr-plugin'
import '.m{overflow:hidden;}.ssr-plugin'
import '.i3{width:32px;}.ssr-plugin'
import '.i4{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="c7 hz i0 by"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="i i1 dj d8 i2 m i3 i4"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
